import EventEmitter from 'eventemitter3';
import * as monaco from 'monaco-editor';
import React from 'react';

export const UNATTRIBUTED_DIAGNOSTICS_URI = 'inmemory://';

let diagnostics: Record<string, monaco.editor.IMarkerData[]> = {};

const eventEmitter = new EventEmitter();
const ApolloGraphqlContext = React.createContext<typeof diagnostics | null>(
  null,
);

export function updateDiagnostics(
  uri: string,
  markers: monaco.editor.IMarkerData[],
) {
  diagnostics = {
    ...diagnostics,
    [uri]: markers,
  };

  eventEmitter.emit('change');
}
export function useApolloGraphqlDiagnostics() {
  const context = React.useContext(ApolloGraphqlContext);
  if (!context) {
    throw new Error(
      `useApolloGraphqlDiagnostics must be used within an ApolloGraphqlDiagnosticsProvider`,
    );
  }
  return context;
}

export function ApolloGraphqlDiagnosticsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [value, setValue] = React.useState(diagnostics);
  React.useEffect(() => {
    const handleChange = () => setValue({ ...diagnostics });
    eventEmitter.on('change', handleChange);
    return () => {
      eventEmitter.off('change', handleChange);
    };
  }, []);

  return (
    <ApolloGraphqlContext.Provider value={value}>
      {children}
    </ApolloGraphqlContext.Provider>
  );
}
